<script setup>
import { onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import adminCorporationService from "../../../../pages/admin/services/corporation/adminCorporationService";
import CorporationInfoView from "../../../../pages/admin/views/corporation/detail/CorporationInfoView.vue";
import CorporationJoinStateView from "../../../../pages/admin/views/corporation/detail/CorporationJoinStateView.vue";
import CorporationJobFairApprovedJoinStateView from "./detail/CorporationJobFairApprovedJoinStateView.vue";
import KSASecondaryButton from "../../../../components/ui-components/button/KSASecondaryButton.vue";
import CorporationJobApplyStateView from "@/pages/admin/views/corporation/detail/CorporationJobApplyStateView.vue";
import CorporationMatchingTabView from "@/pages/admin/views/corporation/CorporationMatchingTabView.vue";

const route = useRoute();
const router = useRouter();
const loaded = ref(false);
const tabRef = ref(null);

const corporation = ref({
  corpId: route.params.id || '',
})

const tabOptions = [
  { label: '기본 정보', value: 'companyInfo' },
  { label: '재직자 가입 현황', value: 'corp-joinState' },
  { label: '상시채용관 진행 현황', value: 'matching-tab' },
  { label: '특별채용관 참가 현황', value: 'jobFair-approved-joinState' },
  { label: '기업홍보관 입사지원 현황', value: 'job-applyState' },
];

const getTabValue = (tab) => {
  return tabOptions.some(option => option.value === tab) ? tab : tabOptions[0].value;
}

const selectedTabValue = ref(getTabValue(route.query.tab));

const onChangeTab = (tab) => {
  if (selectedTabValue.value === tab.value) {
    return;
  }

  const nextQuery = { ...route.query, tab: tab.value };
  if (tab.value !== 'matching-tab' && nextQuery.subTab) {
    delete nextQuery.subTab;
  }

  router.push({ query: nextQuery });
};

// 기업 기본 정보 조회
const retrieveCorpDetail = async () => {
  loaded.value = false;
  //loadingStore.loading = true;
  adminCorporationService.retrieveCorporation(corporation.value.corpId)
      .then( async (res) => {
        //loadingStore.loading = false;
        loaded.value = true;
        // console.log(res);
        if(res.data.code.toLowerCase() === 'success') {
          corporation.value = {
            ...res.data.result,
            corpId: res.data.result?.corpId || corporation.value.corpId,
          };
        } else {
        }
      }).catch( (res) =>  {
    console.log(res);
    //loadingStore.loading = false;
    loaded.value = true;
  });
}

// 목록 버튼
const goBack = () => {
  router.push({ name: 'CorporationList' });
}

onMounted(()=>{
  loaded.value = false;
  const { id } = route.params;
  if(!id) {
    goBack();
  } else {
    if (!corporation.value.corpId) {
      corporation.value.corpId = id;
    }
    retrieveCorpDetail()
  }

  if (tabRef.value) {
    tabRef.value.init(selectedTabValue.value);
  }
})

watch(
    () => route.query.tab,
    (tab) => {
      const nextTabValue = getTabValue(tab);
      selectedTabValue.value = nextTabValue;

      if(tabRef.value) {
        tabRef.value.init(nextTabValue);
      }
    },
    { immediate: true }
);
</script>

<template>
  <div class="content">
    <div class="sub-title">
      <h3>{{ corporation.corpName }} 기업 정보</h3>
    </div>
    <div class="btn-wrap space-between mb-xs">
      <div>
        <KSASecondaryButton class="gray_button" text="목록" @click="goBack" />
      </div>
    </div>
    <div class="tab-wrap mb-sm">
      <KSATab
          ref="tabRef"
          :options="tabOptions"
          @change="onChangeTab"
          style="grid-template-columns: repeat(5, 1fr);"
      />
    </div>
    <div v-if="selectedTabValue === 'companyInfo'">
      <CorporationInfoView :corporation="corporation" @refresh="retrieveCorpDetail" />
    </div>
    <div v-else-if="selectedTabValue === 'corp-joinState'">
      <CorporationJoinStateView :corporation="corporation" />
    </div>
    <div v-else-if="selectedTabValue === 'matching-tab'">
      <CorporationMatchingTabView :corporation="corporation" />
    </div>
    <div v-else-if="selectedTabValue === 'jobFair-approved-joinState'">
      <CorporationJobFairApprovedJoinStateView :corporation="corporation" />
    </div>
    <div v-else-if="selectedTabValue === 'job-applyState'">
      <CorporationJobApplyStateView :corporation="corporation" />
    </div>
  </div>
</template>


<style lang="scss" scoped>
@import "../../../../assets/scss/theme";
</style>
